var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',_vm._l((_vm.allTees),function(item,index){return _c('v-col',{key:index,attrs:{"cols":"12","md":"4","sm":"6"}},[_c('div',{staticClass:"card"},[_c('img',{attrs:{"src":item.image,"alt":""}}),_c('p',[_vm._v(_vm._s(item.description))])])])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }